module.exports = __webpack_public_path__ + "static/media/paquete serum plex.fe68fcd7.png";